/* eslint-disable */
import { Status, Description } from '../models/service.model';
import { OfferType } from '../models/replacement.offer.model';
import { ReplacementOffer } from '../models/replacement.offer.model';

export const ReplacementOffersData: ReplacementOffer[] = [
  {
    item_code: 'AW',
    warranty: 12,
    manuf_code: 'BEKO',
    make: 'BEKO',
    model: 'WTG620M2W',
    colour: 'White',
    offer_type: OfferType.UPGRADE,
    display_order: 1,
    upgrade_fee: 10.0,
    rrp: 215.42,
    article_id: 2146903247,
    appliance_category: 'Washing Machine',
    short_description: 'BEKO WTG620M2W Washing Machine',
    long_description: 'BEKO WTG620M2W Washing Machine White A+++ 6 1200',
    selected: true,
    supplier_name: 'RGB',
    cat_num: 'WTG620M2W',
    supplier_id: 6684,
    services: [
      {
        cat_num: 'DELRGB',
        charge_type: 1,
        status: Status.F,
        description: Description.Delivery,
        price_net: 0,
        price_gross: 0,
        charge_customer: false,
      },
      {
        cat_num: 'INSRGB',
        charge_type: 2,
        status: Status.C,
        description: Description.Installation,
        price_net: 16.666666,
        price_gross: 20,
        charge_customer: true,
      },
      {
        cat_num: 'REMOVALRGBWM',
        charge_type: 3,
        status: Status.C,
        description: Description.Disposal,
        price_net: 10,
        price_gross: 12,
        charge_customer: true,
      },
    ],
    summary_specs: [
      'Slim depth',
      'Large porthole door',
      'Hand wash program',
      'Child safety lock',
    ],
    images: [
      {
        text: 'Front',
        url: 'https://cdn.cnetcontent.com/8d/7f/8d7f1746-55f1-441a-90fe-9f70ccac637a.jpg',
      },
    ],
    compare_specs: [
      {
        name: 'Bluetooth',
        value: 'No',
      },
      {
        name: 'Construction',
        value: 'Freestanding',
      },
      {
        name: 'Delay Timer',
        value: 'Yes',
      },
      {
        name: 'Depth',
        value: '415',
      },
      {
        name: 'Energy Efficiency',
        value: 'A+++',
      },
      {
        name: 'Height',
        value: '840',
      },
      {
        name: 'Loading',
        value: 'Front Loader',
      },
      {
        name: 'Make',
        value: 'Beko',
      },
      {
        name: 'ReleaseDate',
        value: 'Aug 30 2017 12:00AM',
      },
      {
        name: 'Spin Efficiency',
        value: 'B',
      },
      {
        name: 'Spin Speed',
        value: '1200',
      },
      {
        name: 'Type',
        value: 'Washing machine',
      },
      {
        name: 'Wash Capacity',
        value: '6',
      },
      {
        name: 'Wash Efficiency',
        value: 'A',
      },
      {
        name: 'Width',
        value: '600',
      },
      {
        name: 'WiFi',
        value: 'No',
      },
    ],
    detailed_specs: [
      {
        name: 'Product Description',
        value:
          'Beko WTG620M2 washing machine - front loading - freestanding - white',
      },
      {
        name: 'Product Type',
        value: 'Washing machine - front loading',
      },
      {
        name: 'Energy Class',
        value: 'Class A+++',
      },
      {
        name: 'Loading Capacity',
        value: '6 kg',
      },
      {
        name: 'Energy Consumption per Year',
        value: '152 kWh',
      },
      {
        name: 'Water Consumption per Year',
        value: '8799 liters',
      },
      {
        name: 'Spin Class',
        value: 'Class B',
      },
      {
        name: 'Spin Speed',
        value: 'Variable - 1200 rpm (max)',
      },
      {
        name: 'Residual Moisture',
        value: '53%',
      },
      {
        name: 'Noise Level (Washing)',
        value: '62 dB',
      },
      {
        name: 'Noise Level (Spinning)',
        value: '77 dB',
      },
      {
        name: 'Maximum Noise Level',
        value: '77 dB',
      },
      {
        name: 'Form Factor',
        value: 'Freestanding',
      },
      {
        name: 'Color',
        value: 'White',
      },
      {
        name: 'Control Type',
        value: 'Electronic',
      },
      {
        name: 'Washer Drum Capacity',
        value: '39 liters',
      },
      {
        name: 'Washing Efficiency',
        value: 'Class A',
      },
      {
        name: 'Programs Qty',
        value: '15',
      },
      {
        name: 'Safety Features',
        value:
          'Water overflow protection system, electromechanical door lock, ChildLock',
      },
      {
        name: 'Energy Consumption per Cycle',
        value: '0.78 kWh',
      },
      {
        name: 'Water Consumption per Cycle',
        value: '40 liters',
      },
      {
        name: 'Voltage',
        value: '230 V / 50 Hz',
      },
      {
        name: 'Dimensions (WxDxH)',
        value: '60 cm x 41.5 cm x 84 cm',
      },
      {
        name: 'Weight',
        value: '56 kg',
      },
      {
        name: 'Standard Washing Program',
        value: 'Cotton',
      },
      {
        name: 'Door Opening Angle',
        value: '170 degrees',
      },
      {
        name: 'Door Opening Diameter',
        value: '30 cm',
      },
      {
        name: 'Out-Of-Balance Detection',
        value: 'Yes',
      },
      {
        name: 'Exterior Color',
        value: 'White',
      },
      {
        name: 'Drum Material',
        value: 'Stainless steel',
      },
      {
        name: 'Average Cycle Time',
        value: '250 minutes',
      },
      {
        name: 'Timer Settings Features',
        value: 'Start timer delay',
      },
      {
        name: 'Maximum Start Timer Delay',
        value: '9 hours',
      },
      {
        name: 'Indicators',
        value: 'Wash progress indicator',
      },
      {
        name: 'Type',
        value: 'Digital',
      },
      {
        name: 'Special Programs & Options',
        value: `Daily wash, half-load, quick wash, pre-wash, cotton, synthetics,
          hand wash, dark garments, Baby, drain + spin, cotton eco, rinse hold,
          extra rinse, rinse, mix, drum cleaning`,
      },
      {
        name: 'Wheels & Leveling',
        value: 'Adjustable feet',
      },
      {
        name: 'Water Connection',
        value: 'Cold',
      },
      {
        name: 'Max Power Consumption',
        value: '1550 W',
      },
      {
        name: 'Power Consumption Off-Mode',
        value: '0.25 W',
      },
      {
        name: 'Power Consumption Left-on Mode',
        value: '0.75 W',
      },
      {
        name: 'Rated Current',
        value: '10 A',
      },
      {
        name: 'Width',
        value: '60 cm',
      },
      {
        name: 'Depth',
        value: '41.5 cm',
      },
      {
        name: 'Height',
        value: '84 cm',
      },
      {
        name: 'Width (Shipping)',
        value: '65 cm',
      },
      {
        name: 'Depth (Shipping)',
        value: '46.5 cm',
      },
      {
        name: 'Height (Shipping)',
        value: '88 cm',
      },
      {
        name: 'Weight (Shipping)',
        value: '57 kg',
      },
    ],
  },
  {
    item_code: 'AW',
    warranty: 12,
    manuf_code: 'HOTP',
    make: 'Hotpoint',
    model: 'WMAQF641P',
    colour: 'White',
    offer_type: OfferType.UPGRADE,
    display_order: 1,
    upgrade_fee: 34.9,
    rrp: 0.99,
    article_id: 2147038888,
    appliance_category: 'Washing Machine',
    short_description: 'Hotpoint WMAQF641P Washing Machine',
    long_description: 'Hotpoint WMAQF641P Washing Machine White A+ 6 1400',
    selected: false,
    supplier_name: 'RGB',
    cat_num: 'WMAQF641P',
    supplier_id: 6684,
    services: [
      {
        cat_num: 'DELRGB',
        charge_type: 1,
        status: Status.F,
        description: Description.Delivery,
        price_net: 0,
        price_gross: 0,
        charge_customer: false,
      },
      {
        cat_num: 'INSRGB',
        charge_type: 2,
        status: Status.C,
        description: Description.Installation,
        price_net: 16.666666,
        price_gross: 20,
        charge_customer: true,
      },
      {
        cat_num: 'REMOVALRGBWM',
        charge_type: 3,
        status: Status.C,
        description: Description.Disposal,
        price_net: 10,
        price_gross: 12,
        charge_customer: true,
      },
    ],
    summary_specs: [
      'Baby cycle',
      'Eco Tech',
      'Anti-stain technology',
      'Woolmark platinum care',
      'Anti-allergy program',
      'Fast wash programs',
      'Selectable child lock',
      'Delay start',
    ],
    images: [
      {
        text: 'Right-angle',
        url: 'https://cdn.cnetcontent.com/cf/4b/cf4bf570-94c1-4a2e-b48e-51ebbc7ec7a0.jpg',
      },
      {
        text: 'Front',
        url: 'https://cdn.cnetcontent.com/b5/43/b5433160-b5fd-4079-841f-fdec33f0fc02.jpg',
      },
      {
        text: 'Close-up',
        url: 'https://cdn.cnetcontent.com/c3/2c/c32c3fc3-a211-4af6-bf17-c17528aaa39c.jpg',
      },
    ],
    compare_specs: [
      {
        name: 'Bluetooth',
        value: 'No',
      },
      {
        name: 'Construction',
        value: 'Freestanding',
      },
      {
        name: 'Delay Timer',
        value: 'Yes',
      },
      {
        name: 'Depth',
        value: '540',
      },
      {
        name: 'Drying Function',
        value: 'No',
      },
      {
        name: 'Energy Efficiency',
        value: 'A+',
      },
      {
        name: 'Height',
        value: '850',
      },
      {
        name: 'Loading',
        value: 'Front Loader',
      },
      {
        name: 'Make',
        value: 'Hotpoint',
      },
      {
        name: 'ReleaseDate',
        value: 'Jan 20 2014 12:00AM',
      },
      {
        name: 'Spin Efficiency',
        value: 'B',
      },
      {
        name: 'Spin Speed',
        value: '1400',
      },
      {
        name: 'Type',
        value: 'Washing machine',
      },
      {
        name: 'Wash Capacity',
        value: '6',
      },
      {
        name: 'Wash Efficiency',
        value: 'A',
      },
      {
        name: 'Width',
        value: '595',
      },
      {
        name: 'WiFi',
        value: 'No',
      },
    ],
    detailed_specs: [
      {
        name: 'Product Description',
        value:
          'Hotpoint WMAQF 641P washing machine - front loading - freestanding - white',
      },
      {
        name: 'Product Type',
        value: 'Washing machine - front loading',
      },
      {
        name: 'Energy Class',
        value: 'Class A+',
      },
      {
        name: 'Loading Capacity',
        value: '6 kg',
      },
      {
        name: 'Energy Consumption per Year',
        value: '196 kWh',
      },
      {
        name: 'Water Consumption per Year',
        value: '8643 liters',
      },
      {
        name: 'Spin Class',
        value: 'Class B',
      },
      {
        name: 'Spin Speed',
        value: 'Variable - 1400 rpm (max)',
      },
      {
        name: 'Residual Moisture',
        value: '53%',
      },
      {
        name: 'Noise Level (Washing)',
        value: '58 dB',
      },
      {
        name: 'Noise Level (Spinning)',
        value: '80 dB',
      },
      {
        name: 'Maximum Noise Level',
        value: '80 dB',
      },
      {
        name: 'Form Factor',
        value: 'Freestanding',
      },
      {
        name: 'Color',
        value: 'White',
      },
      {
        name: 'Washer Drum Capacity',
        value: '52 liters',
      },
      {
        name: 'Programs Qty',
        value: '16',
      },
      {
        name: 'Safety Features',
        value: 'Child security, water overflow protection system',
      },
      {
        name: 'Dimensions (WxDxH)',
        value: '59.5 cm x 54 cm x 85 cm',
      },
      {
        name: 'Weight',
        value: '66 kg',
      },
      {
        name: 'Manufacturer Warranty',
        value: '1 year',
      },
      {
        name: 'Standard Washing Program',
        value: 'Cotton',
      },
      {
        name: 'Duration of the Left-on Mode',
        value: '30 min',
      },
      {
        name: 'Program Time Details',
        value: '195 min - washing - full load - 60 °C',
      },
      {
        name: 'Exterior Color',
        value: 'White',
      },
      {
        name: 'Timer Settings Features',
        value: 'Start timer delay',
      },
      {
        name: 'Type',
        value: 'Digital',
      },
      {
        name: 'Special Programs & Options',
        value: `Quick wash, Woolmark Platinum Care, Baby, Super Wash,
          anti-allergy, pause option, daily 30', eco wash`,
      },
      {
        name: 'Features',
        value:
          'Ecotech, anti-stain system, variable temperature, spin speed selection',
      },
      {
        name: 'Exterior Features',
        value: 'White door',
      },
      {
        name: 'Compliant Standards',
        value: 'Directive 1061/2010/EU',
      },
      {
        name: 'Energy Consumption Details',
        value: '1.05 kWh - washing - full load - 60 °C',
      },
      {
        name: 'Power Consumption Off-Mode',
        value: '0.5 W',
      },
      {
        name: 'Power Consumption Left-on Mode',
        value: '8 W',
      },
      {
        name: 'Width',
        value: '59.5 cm',
      },
      {
        name: 'Depth',
        value: '54 cm',
      },
      {
        name: 'Height',
        value: '85 cm',
      },
      {
        name: 'Width (Shipping)',
        value: '64 cm',
      },
      {
        name: 'Depth (Shipping)',
        value: '59 cm',
      },
      {
        name: 'Height (Shipping)',
        value: '89 cm',
      },
      {
        name: 'Warranty',
        value: '1 year',
      },
    ],
  },
];

export const ReplacementOffersDataSet = [
  ...ReplacementOffersData,
  ...ReplacementOffersData,
  ...ReplacementOffersData,
  ...ReplacementOffersData,
  ...ReplacementOffersData,
  ...ReplacementOffersData,
  ...ReplacementOffersData,
].map((offer, index) => {
  offer.article_id = index;
  return Object.assign({}, offer);
});

export const EnhancedOffersData = [
  ...ReplacementOffersData,
  ...ReplacementOffersData,
  ...ReplacementOffersData,
  ...ReplacementOffersData,
  ...ReplacementOffersData,
  ...ReplacementOffersData,
  ...ReplacementOffersData,
].map((offer, index) => {
  offer.article_id = index + 1000;
  return Object.assign({}, offer);
});
